import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { NgModule } from '@angular/core';
import { UnauthorizedLandingComponent } from 'unauthorized-landing';
import { PtImageMappingComponent } from './modules/pt-image-mapping/components/pt-image-mapping.component';
import { ViewImageComponent } from './modules/view-images/components/view-image.component';
import { SpecimenBasedComponent } from './modules/pt-image-mapping/specimen-based/specimen-based.component';
import { CaseBasedComponent } from './modules/pt-image-mapping/case-based/case-based.component';
import { AuthGuard } from './core/guards/auth.guard';

const appRoutes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
	{ path: 'home', component: PtImageMappingComponent, canActivate: [AuthGuard] },
	{ path: 'mailing/:mailingID/images', component: SpecimenBasedComponent, canActivate: [AuthGuard] },
	{ path: 'anatomic-site/:anatomicSiteCode/images', component: CaseBasedComponent, canActivate: [AuthGuard] },
	{ path: 'case/:caseNumber/images', component: CaseBasedComponent, canActivate: [AuthGuard] },
	{ path: 'kit/:kitNumber/images', component: ViewImageComponent, canActivate: [AuthGuard] },
	{ path: 'unauthorized', component: UnauthorizedLandingComponent }
];

@NgModule({
	imports: [
		RouterModule.forRoot(appRoutes, {
			useHash: true,
			onSameUrlNavigation: 'reload',
			preloadingStrategy: PreloadAllModules
		})
	],
	exports: [
		RouterModule
	]
})
export class AppRoutingModule { }
